export default "__VITE_ASSET__93b38816__"